import { NgModule } from "@angular/core";
import { LeftMenuComponent } from "./left-menu/left-menu.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../shared.module";
import { AppRoutingModule } from "../app-routing.module";

@NgModule({
  imports: [BrowserAnimationsModule, SharedModule, AppRoutingModule, LeftMenuComponent],
  declarations: [],

  exports: [
    LeftMenuComponent,
    SharedModule,
    AppRoutingModule,
  ],
})
export class MenuModule { }
